<template>
  <div class="pw-tool">
    <div class="editor-pane" v-if="!loading && !done">
      <div class="pane-header">
        <span class="pane-dot input-dot" /><span class="pane-label">{{ $t('tool.PptToWord.upload') }}</span>
        <span class="pane-hint">{{ $t('tool.PptToWord.uploadHint') }}</span>
      </div>
      <el-upload ref="upload" drag action="#" :auto-upload="false" :on-change="handleFile" :limit="1"
        accept=".ppt,.pptx" :file-list="fileList">
        <i class="el-icon-upload" style="font-size:42px;color:#c0c4cc" />
        <div class="el-upload__text">{{ $t('tool.PptToWord.dropText') }}<em>{{ $t('tool.PptToWord.clickUpload') }}</em></div>
      </el-upload>
      <div style="text-align:center;margin-top:12px" v-if="file">
        <span class="pw-file">{{ file.name }}</span>
        <el-button type="primary" size="small" @click="convert" style="margin-left:10px">{{ $t('tool.PptToWord.btnConvert') }}</el-button>
      </div>
    </div>

    <div class="editor-pane pw-state" v-if="loading">
      <div class="pane-header"><span class="pane-dot pw-dot-load" /><span class="pane-label">{{ $t('tool.PptToWord.title') }}</span></div>
      <div class="pw-state-inner">
        <i class="el-icon-loading" />
        <p>{{ $t('tool.PptToWord.processing') }}</p>
      </div>
    </div>

    <div class="editor-pane pw-state" v-if="done">
      <div class="pane-header"><span class="pane-dot output-dot" /><span class="pane-label">{{ $t('tool.PptToWord.title') }}</span></div>
      <div class="pw-state-inner">
        <i class="el-icon-success pw-icon-done" />
        <p>{{ $t('tool.PptToWord.generated') }}</p>
        <div class="pw-done-actions">
          <a :href="downloadUrl" download="presentation.docx" class="el-button el-button--primary el-button--small" style="text-decoration:none;color:#fff">{{ $t('tool.PptToWord.download') }}</a>
          <el-button size="small" plain @click="reset">{{ $t('tool.PptToWord.reupload') }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { convertPptToWord } from '@/api/site'
export default {
  name:'PptToWordTool',props:{config:{type:Object,default:()=>({})}},
  data:()=>({file:null,fileList:[],loading:false,done:false,downloadUrl:''}),
  methods:{
    handleFile(f){if(f.size>50*1024*1024){this.$message.error(this.$t('tool.PptToWord.maxSize'));return}this.file=f.raw;this.fileList=[f]},
    async convert(){if(!this.file)return;this.loading=true;try{var fd=new FormData();fd.append('file',this.file);var res=await convertPptToWord(fd);this.downloadUrl=res.data;this.done=true}catch(e){this.$message.error(this.$t('tool.PptToWord.convertFail')+': '+(e.message||''))};this.loading=false},
    reset(){this.done=false;this.file=null;this.fileList=[];this.downloadUrl=''},
    doAction(a){if(a==='clear')this.reset()}
  }
}
</script>

<style scoped>
.pw-tool { display:flex;flex-direction:column;gap:16px; }
.editor-pane { background:#fafbfc;border-radius:12px;border:1px solid #ebeef5;padding:16px 20px; min-width:0; overflow:hidden; }
.pane-header { display:flex;align-items:center;gap:8px;margin-bottom:12px; flex-wrap:wrap; }
.pane-dot { width:8px;height:8px;border-radius:50%;flex-shrink:0; }
.input-dot { background:#4e7cff;box-shadow:0 0 6px rgba(78,124,255,.4); }
.output-dot { background:#43e97b;box-shadow:0 0 6px rgba(67,233,123,.4); }
.pw-dot-load { background:#e6a23c;box-shadow:0 0 6px rgba(230,162,60,.4); }
.pane-label { font-size:13px;font-weight:700;color:#1a1f36; }
.pane-hint { font-size:11px;color:#b0b8c4;margin-left:auto; white-space:nowrap; }
.pw-file { font-size:13px;color:#606266; }
.pw-tool ::v-deep .el-upload { width:100%; }
.pw-tool ::v-deep .el-upload-dragger { display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:170px; max-width:100%; width:100%; box-sizing:border-box; }

.pw-state { text-align:center; }
.pw-state-inner { padding:20px 0; }
.pw-state-inner i { font-size:36px;color:#4e7cff; }
.pw-state-inner .pw-icon-done { color:#67c23a; }
.pw-state-inner p { margin:10px 0;font-size:14px;color:#606266; }
.pw-done-actions { display:flex;gap:8px;justify-content:center;margin-top:10px; }

@media (max-width: 640px) {
  .editor-pane { padding:12px 14px; }
  .pane-hint { display:none; }
  .pw-tool ::v-deep .el-upload-dragger { min-height:140px;padding:20px 12px; }
  .pw-tool ::v-deep .el-upload__text { font-size:12px; }
}
</style>
